import { useState, useContext, useEffect, useRef } from 'react';
import Context from '../components/context.js';
import { AccessContext } from '../components/context.js';
import EventCard from '../components/event-card.js';
import MerchCard from '../components/merch-card.js';
import EpisodeCard from '../components/episode-card.js';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Dialog from '../components/dialog.jsx';
import VideoCard from '../components/video-card.js';
import ImageCard from '../components/image-card.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LinkCard from '../components/link-card.js';
import {  faRepeat, faImage, faPlusCircle, faGlobe, faDownload } from '@fortawesome/free-solid-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { SortableContainer } from '../components/sortable.jsx';
import FileDragDrop from '../components/drag-drop.jsx';
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import Expandable from '../components/expandable.js';
import RTE from '../components/rte.jsx';

const ModulePosition = ({ position, setPositions, index }) => {
    const inc = () => {
        if (position == 6)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === position + 1);
            p[i]--;
            p[index]++;
            return p;
        })
    }
    const dec = () => {
        if (position == 1)
            return;
        setPositions(_p => {
            let p = [..._p];
            let i = p.findIndex(a => a === position - 1);
            p[i]++;
            p[index]--;
            return p;
        })
    }
    return (
        <div className="module-order">
            <button onClick={dec} disabled={position == 1}>{'\u25C0'}</button>
            <div>{position}</div>
            <button onClick={inc} disabled={position == 6}>{'\u25B6'}</button>
        </div>
    )
}
const Host = () => {
    const navigate = useNavigate();
    const { role, metaData, isSuper } = useContext(AccessContext);
    var _sid = undefined;
    if (role == 'Host/Guest')
        _sid = metaData.speakerId
    const now = new Date();
    const location = useLocation();
    const addVideoRef = useRef(null);
    const addImageRef = useRef(null);
    const cropperRef = useRef(null);
    const cropImageRef = useRef(null);
    const linkRef = useRef(null);
    const [videoUrl, setVideoUrl] = useState('');
    const [toAddImagesTitle, setToAddImagesTitle] = useState('');
    const [toAddVideoTitle, setToAddVideoTitle] = useState('');
    const [imageFiles, setImageFiles] = useState([]);
    const [crop, setCrop] = useState();
    const [pixelCrop, setPixelCrop] = useState();
    const [displayImage, setDisplayImage] = useState(null);
    const [id, setId] = useState(location.state?.id || _sid);
    const setContext = useContext(Context)[1];
    const addProfessionRef = useRef(null);
    useEffect(() => {
        setId(id || location.state?.id || _sid);
    }, [_sid]);
    if (id)
        setContext('Edit Host/Guest');
    else
        setContext('Add Host/Guest');
    const defaultHost = {
        imageUrl: '',
        firstName: '',
        lastName: '',
        description: '',
        createdDate: '',
        createdBy: '',
        updatedDate: '',
        updatedBy: '',
        isHost: 'true',
        isGuest: 'true',
        events: [],
        socials: [],
        merch: [],
        episodes: [],
        images: [],
        videos: [],
        links: [],
        metaData: {}
    }
    const [host, setHost] = useState(defaultHost);
    const [professions, setProfessions] = useState([]);
    const [positions, setPositions] = useState([1, 2, 3, 4, 5, 6]);
    const [loading, setLoading] = useState(id ? true : false);
    const [events, setEvents] = useState([]);
    const [merch, setMerch] = useState([]);
    const [eventId, setEventId] = useState(-1);
    const [merchId, setMerchId] = useState(-1);
    const [file, setFile] = useState(null);
    const [fp, setFP] = useState('');
    const [videoContainerWidth, setVideoContainerWidth] = useState('100%');
    const [deleteImage, setDeleteImage] = useState(false);
    const [isDownload, setIsDownload] = useState(false);
    const [linkAddSection, setLinkAddSection] = useState(0);
    const [newLinkText, setNewLinkText] = useState('');
    const [newLinkURL, setNewLinkURL] = useState('');
    const [downloadFile, setDownloadFile] = useState([]);
    const [downloadFP, setDownloadFP] = useState('');
    const [selectedProfession, setSelectedProfession] = useState('');
    const profileImageUploadRef = useRef(null);
    const videoDialogClose = () => {
        setVideoUrl('');
        setToAddVideoTitle('');
        setVideoContainerWidth('100%');
    }
    const imageDialogClose = () => {
        setImageFiles([]);
        setToAddImagesTitle('');
        setPixelCrop();
        setCrop();
    }
    function fillArrayUpToN(arr, n) {
        const TARGET_NUMBER = n;

        if (arr.length < TARGET_NUMBER) {
            const startNum = arr.length + 1;
            for (let i = startNum; i <= TARGET_NUMBER; i++) {
                arr.push(i);
            }
        }

        return arr;
    }
    const loadHost = () => {
        axios.post(process.env.REACT_APP_API_URL + 'host', {
            id: id
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                if (r.data.results.moduleOrder)
                    setPositions(fillArrayUpToN(r.data.results.moduleOrder.split(',').map(n => parseInt(n)), 6));
                r.data.results.merch = r.data.results.merch.map((m) => {
                    if (m?.imageUrl)
                        m.images.splice(0, 0, m.imageUrl);
                    return m;
                });
                r.data.results.socials = r.data.results.socials || [];
                r.data.results.videos = r.data.results.videos || [];
                r.data.results.images = r.data.results.images || [];
                setHost(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'profession').then(r => {
            if (r?.data?.status === 'Success') {
                setProfessions(r.data.results.map(r => r.text));
            }
        });
    }
    useEffect(() => {
        if (id) {
            loadHost();
        } else {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        axios.post(process.env.REACT_APP_API_URL + 'event').then(r => {
            if (r?.data?.status === 'Success') {
                setEvents(r.data.results);
            }
        });
        axios.post(process.env.REACT_APP_API_URL + 'merch').then(r => {
            if (r?.data?.status === 'Success') {
                setMerch(r.data.results);
            }
        });
    }, []);
    const setValue =(key, value) => {
        setHost(h => {
            let _h = { ...h };
            _h[key] = value;
            return _h;
        });
    }
    const setSocial = (key, value) => {
        setHost(h => {
            let _h = { ...h };
            _h.socials = _h.socials || [];
            let i = _h.socials?.findIndex(s => s.type === key);
            if (i >= 0) {
                _h.socials[i].url = value;
            } else {
                _h.socials.push({ type: key, url: value });
            }
            return _h;
        });
    }
    const setMetaData = (key, value) => {
        setHost(h => {
            let _h = { ...h };
            _h.metaData = _h.metaData || {};
            _h.metaData[key] = value;
            return _h;
        });
    }
    const getSocialUrl = (key) => {
        let h = host.socials?.find(s => s.type === key);
        return h ? h.url : '';
    }
    const save = () => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('firstName', host.firstName);
        formData.append('lastName', host.lastName);
        formData.append('description', host.description);
        formData.append('imgUrl', host.imageUrl);
        formData.append('moduleOrder', positions.join(','));
        formData.append('isGuest', host.isGuest || '');
        formData.append('isHost', host.isHost || '');
        formData.append('events', JSON.stringify((host.events || []).map(a => a.id)));
        formData.append('videos', JSON.stringify(host.videos));
        formData.append('images', JSON.stringify((host.images || []).map(h => h.id)));
        formData.append('merch', JSON.stringify((host.merch || []).map(a => a.id)));
        formData.append('socials', JSON.stringify(host.socials || []));
        formData.append('links', JSON.stringify((host.links || []).map(l => ({text: l.text, url: l.url, isDownload: l.isDownload ? 1 : 0}))));
        formData.append('metaData', JSON.stringify(host.metaData || {}));
        formData.append('deleteImage', deleteImage);
        if (!id) {
            axios.post(process.env.REACT_APP_API_URL + 'speaker/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    toast.success('Saved');
                    setId(r.data.id);
                    setEventId(-1);
                    setMerchId(-1);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                }
            });
        } else {
            formData.append('id', id);
            axios.post(process.env.REACT_APP_API_URL + 'speaker/update', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(r => {
                if (r?.data?.status === 'Success') {
                    if (role == 'Host/Guest' && !isSuper) {
                        console.log('Updating user account');
                        axios.post(process.env.REACT_APP_API_URL + 'user/update', {
                            firstName: host.firstName,
                            lastName: host.lastName
                        }).then(r => {
                            if (r?.data?.status === 'Success') {
                                localStorage.setItem('jwt', r.data.token);
                            }
                        });
                    }
                    toast.success('Saved');
                    setEventId(-1);
                    setMerchId(-1);
                    setFile(null);
                    setFP('');
                    setDeleteImage(false);
                    setLoading(true);
                    loadHost();
                }
            });
        }
    }
    const _delete = () => {
        if (!id)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'host/delete', {
            ids: JSON.stringify([id]),
            urls: JSON.stringify([host.imageUrl])
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                navigate('/host-list');
            }
        });
    }
    const filterArrays = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a.id === b.id;
            });
        });
    }
    const filterArrays2 = (arrA, arrB) => {
        return (arrA || []).filter(a => {
            return !(arrB || []).some(b => {
                return a === b;
            });
        });
    }
    const professionDialogClose = () => {
        setSelectedProfession('');
    }
    const [isDragging, setIsDragging] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);

    const processFile = (files) => {
        if (files && files.length > 0) {
        const file = files[0];
        
        // Ensure the uploaded file is an image
        if (file.type.startsWith('image/')) {
            const imageUrl = URL.createObjectURL(file);
            setPreviewUrl(imageUrl);
            
        } else {
            alert('Please upload an image file.');
        }
        }
    };
    
    function formatDate(dateInput) {
        const date = new Date(dateInput);

        // Format the date portion: "Apr 17, 2026"
        const datePart = date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });

        // Format the time portion: "2:41 PM"
        const timePart = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });

        // Combine them
        return `${datePart} at ${timePart}`;
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        processFile(e.dataTransfer.files);
        e.dataTransfer.clearData();
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setFP(e.target.value);
        processFile(e.target.files);
    };
    if (loading) {
        return (
            <div className="loading mt-50" style={{ color: '#AAA5BF' }}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        )
    }
    const getMaxId = (arr) => {
        if (arr.length === 0) return 0;
        return Math.max(...arr.map(item => item.id));
    };
    return (
        <main>
            <Dialog ref={addProfessionRef} onClose={professionDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addProfessionRef.current.hide();
                        professionDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={selectedProfession == ''} onClick={() => {
                        var newProfessions = [...(host.metaData?.professions || []), selectedProfession];
                        setMetaData('professions', newProfessions);
                        addProfessionRef.current.hide();
                        professionDialogClose();
                    }}>Add Profession</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, minWidth: 400 }} className="w-100 p-rel">
                    <label className="mb-25" style={{display: 'block'}}>Add Profession</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <select className="w-100 p-5" value={selectedProfession} onChange={e => setSelectedProfession(e.target.value)}>
                            <option value="">Please Select...</option>
                            {filterArrays2(professions, host.metaData?.professions || []).map((p, i) => {
                                return (
                                    <option key={i} value={p}>{p}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addVideoRef} onClose={videoDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addVideoRef.current.hide();
                        videoDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={videoUrl == ''} onClick={() => {
                        addVideoRef.current.hide();
                        if (videoUrl == '')
                            return;
                        var vid = host.videos.find(v => v.videoUrl.toLowerCase() == videoUrl.toLowerCase());
                        if (vid) {
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return;
                        }
                        setHost(_e => {
                            let e = { ..._e };
                            e.videos = e.videos || [];
                            e.videos.push({ videoUrl: videoUrl, title: toAddVideoTitle, id: getMaxId(e.videos) + 1 });
                            setVideoUrl('');
                            setToAddVideoTitle('');
                            return e;
                        });
                    }}>Add Video</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, maxWidth: 400 }} className="w-100 p-rel">
                    <label className="mb-25" style={{display: 'block'}}>Add Video</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row mb-10 flex f-wrap">
                        <label style={{marginBottom: -5}} htmlFor="find-video" className="w-100 text-sm">Video URL</label>
                        <input type="text" id="find-video" className="w-50" placeholder="Video URL" style={{flexGrow: 1}} value={videoUrl} onChange={e => {
                            setVideoUrl(e.target.value);
                            setVideoContainerWidth(e.target.value.toLowerCase().includes("shorts") || e.target.value.toLowerCase().includes("tiktok") ? 150 : '100%');
                        }} />
                        <label style={{marginBottom: -5}} className="mt-15 w-100 text-sm">Video Title (Optional)</label>
                        <input type="text" placeholder="Video Title" value={toAddVideoTitle} className="w-100" aria-label="Video Title" onChange={(e) => setToAddVideoTitle(e.target.value)} />
                        <label style={{marginBottom: -5}} className="w-100 mt-15 text-sm">Video Preview</label>
                        {!!videoUrl ? <div style={{width: videoContainerWidth}} className="preview-container mt-0"><VideoCard video={{
                            videoUrl: videoUrl, title: toAddVideoTitle
                        }} /></div> : (
                            <div className="no-video-preview w-100 mt-0">
                                <FontAwesomeIcon icon={faYoutube} style={{fontSize: 64}} />
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={addImageRef} onClose={imageDialogClose} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        addImageRef.current.hide();
                        imageDialogClose();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={imageFiles.length == 0 || !imageFiles[0].file || !imageFiles[0].thumbnail} onClick={() => {
                        if (imageFiles.length == 0 || !imageFiles[0].file)
                            return;
                        if (!imageFiles[0].thumbnail) {
                            toast.error('Create a thumbnail to continue');
                            return;
                        }
                        var formData = new FormData();
                        formData.append('image', imageFiles[0].file);
                        formData.append('thumbnail', imageFiles[0].thumbnail);
                        formData.append('title', toAddImagesTitle);
                        
                        axios.post(process.env.REACT_APP_API_URL + 'image/add', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then(r => {
                            if (r?.data?.status === 'Success') {
                                axios.post(process.env.REACT_APP_API_URL + 'image', {id: r.data.id})
                                    .then(_r => {
                                        if (_r?.data?.status === 'Success') {
                                            toast.success('Image Added');
                                            setHost(_e => {
                                                let e = { ..._e };
                                                e.images = e.images || [];
                                                e.images.push({
                                                    id: _r.data.results.id,
                                                    imageUrl: _r.data.results.imageUrl,
                                                    thumbnailUrl: _r.data.results.thumbnailUrl,
                                                    title: _r.data.results.title
                                                });
                                                return e;
                                            });
                                        }
                                        imageDialogClose();
                                        addImageRef.current.hide();
                                    });
                            }
                        });
                    }}>Add Image</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, maxWidth: '100%' }} className="w-100">
                    <label htmlFor="image-file" style={{display: 'block'}} className="mb-20">Add Image</label>
                    <div style={{ flexGrow: 0 }} className="w-100 gap-10 f-row flex f-wrap">
                        {/*<input type="file" id="image-file" accept="image/*" style={{flexGrow: 1}} onChange={(e) => { setFile(e.target.files[0]); setFP(e.target.value) }} value={fp} />*/}
                        {!imageFiles || imageFiles.length == 0 ? (<FileDragDrop files={imageFiles} setFiles={setImageFiles}
                        accept='image/png,image/jpg,image/jpeg' acceptText="JPEG, JPG, PNG" />) :
                        (
                            <div className="w-100 gap-10 f-col f-start flex f-wrap">
                                <label style={{marginBottom: -5}} className="text-sm">Image Title (Optional)</label>
                                <input type="text" placeholder="Image Title" value={toAddImagesTitle} className="w-100" aria-label="Image Title" onChange={(e) => setToAddImagesTitle(e.target.value)} />
                                <div className="flex gap-20 a-start w-100">
                                    <div className="flex gap-10 f-col w-60 f-start">
                                        <label className='mt-10 text-sm'>Image Preview</label>
                                        <div style={{width: '100%'}}>
                                            <img src={imageFiles[0].previewUrl} alt={toAddImagesTitle} />
                                            {!!toAddImagesTitle && (<div className="image-title">
                                                {toAddImagesTitle}
                                            </div>)}
                                        </div>
                                    </div>
                                    <div className="flex gap-10 f-col f-start w-40" style={{alignSelf: 'stretch'}}>
                                        <label className='mt-10 text-sm'>Thumbnail (required)</label>
                                        {!imageFiles[0].thumbnailUrl ? (
                                            <div
                                                role="button"
                                                onClick={() => {
                                                    cropperRef.current.show();
                                                }}
                                                className={`border-2 border-dashed rounded p-30 cursor-pointer transition-shadow`}
                                                style={{ borderColor: 'rgba(156,163,175,0.6)', width: '100%', height: '100%' }}
                                                >
                                                <div className="text-center gap-5 flex f-col f-center a-center" style={{height: '100%', width: '100%'}}>
                                                    <FontAwesomeIcon icon={faImage} style={{fontSize: 48}} />
                                                    <div style={{textDecoration: 'underline'}} className="mt-5 font-bold">Create<br />Tumbnail</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <img onClick={() => cropperRef.current.show()} style={{cursor: 'pointer'}} src={imageFiles[0].thumbnailUrl} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>
            <Dialog ref={cropperRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        cropperRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={!pixelCrop} onClick={() => {
                        if (!pixelCrop) {
                            toast.error('Please make a crop.')
                        }
                        var cropCanvas = document.createElement('canvas');
                        var scale = cropImageRef.current.naturalWidth / cropImageRef.current.width;
                        cropCanvas.width = pixelCrop.width * scale;
                        cropCanvas.height = pixelCrop.height * scale;
                        var ctx = cropCanvas.getContext('2d');
                        ctx.drawImage(
                            cropImageRef.current,
                            pixelCrop.x * scale,
                            pixelCrop.y * scale,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale,
                            0,
                            0,
                            pixelCrop.width * scale,
                            pixelCrop.height * scale
                        );
                        cropCanvas.toBlob((b) => {
                            setImageFiles(i => {
                                var newI = [...i];
                                newI[0].thumbnail = b;
                                newI[0].thumbnailUrl = cropCanvas.toDataURL();
                                return newI;
                            });
                            cropperRef.current.hide();
                        });
                    }}>Add Thumbnail</button>
                </div>
            )}>
                {imageFiles?.length > 0 && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => {
                            setCrop(percentCrop);
                        }}
                        onComplete={(c) => {
                            setPixelCrop(c);
                        }}
                        aspect={1}
                        minHeight={1}
                        >
                        <img ref={cropImageRef}
                            alt="Crop me"
                            style={{width: 400, maxWidth: '80vw'}}
                            src={imageFiles[0].previewUrl}
                        />
                    </ReactCrop>
                )}
            </Dialog>
            <Dialog ref={linkRef} outsideButtons={(
                <div className="flex gap-5 f-end p-abs" style={{bottom: -38, right: 0, background: 'transparent', padding: 0}}>
                    <button className="btn btn-white" onClick={() => {
                        setNewLinkText('');
                        setNewLinkURL('');
                        setIsDownload(false);
                        setLinkAddSection(0);
                        linkRef.current.hide();
                    }}>Cancel</button>
                    <button className="btn btn-white" disabled={linkAddSection == 0} onClick={async () => {
                        if (newLinkText == '' || (newLinkURL == '' && (!downloadFile || downloadFile?.length == 0)))
                            return;
                        var link = host?.links?.find?.(v => v.url.toLowerCase() == newLinkURL.toLowerCase() && v.text.toLowerCase() == newLinkText.toLowerCase());
                        if (link) {
                            setNewLinkText('');
                            setNewLinkURL('');
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return;
                        }
                        var _newLinkUrl = newLinkURL;
                        if (isDownload) {
                            const formData = new FormData();
                            formData.append('file', downloadFile);
                            const data = await axios.post(process.env.REACT_APP_API_URL + 'file/upload', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            });
                            if (data.data.status != 'Success') {
                                toast.error('Failed to upload file.');
                                return;
                            }
                            _newLinkUrl = data.data.url;
                        }
                        setHost(_e => {
                            let e = { ..._e };
                            e.links = e.links || [];
                            e.links.push({ url: _newLinkUrl, text: newLinkText, isDownload: isDownload, id: getMaxId(e.videos) + 1 });
                            setNewLinkText('');
                            setNewLinkURL('');
                            setIsDownload(false);
                            setLinkAddSection(0);
                            return e;
                        });
                        linkRef.current.hide();
                    }}>Add</button>
                </div>
            )}>
                <div style={{ flexGrow: 0, width: 500, height: 223 }} className="w-100">
                    <label className="mb-15" style={{display: 'block'}}>Add Link or Download</label>
                    {linkAddSection == 0 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-15 f-col">
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                style={{borderBottom: '1px solid'}}
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(false);
                                }}>
                                <span>
                                    Create Web Link
                                </span>
                                <FontAwesomeIcon icon={faGlobe} className="add-icon" />
                            </a>
                            <a role="button" className="add-link-type w-100 gap-10 flex f-center a-center"
                                onClick={() => {
                                    setLinkAddSection(1);
                                    setIsDownload(true);
                                }}>
                                <span>
                                    Create Download
                                </span>
                                <FontAwesomeIcon icon={faDownload} className="add-icon" />
                            </a>
                        </div>
                    )}
                    {linkAddSection == 1 && (
                        <div style={{ flexGrow: 0 }} className="flex w-100 gap-10 mt-35 f-row f-wrap">
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="w-100 text-sm">{isDownload ? "Download Title" : "Web Link Title"}</label>
                            <input id="link-text" type="text" className="w-100" value={newLinkText} onChange={(e) => setNewLinkText(e.target.value)} />
                            <label style={{marginBottom: -5}} htmlFor="link-text" className="mt-20 w-100 text-sm">{isDownload ? "Upload File" : "Web Link URL"}</label>{isDownload ? (
                                <input type="file" className="grow" value={downloadFP} onChange={(e) => {
                                    setDownloadFP(e.target.value);
                                    setDownloadFile(e.target.files[0]);
                                }} />
                            ) : (
                                <input id="link-url" type={"text"} className="grow" value={newLinkURL} onChange={(e) => setNewLinkURL(e.target.value)} />
                            )}
                        </div>
                    )}
                </div>
            </Dialog>
            <div className="container w-100 container-small">
                <h1 className="page-title">Host Profile</h1>
                <h2 className="page-subtitle">Manage your host information and social presence.</h2>
                <div className="form speaker-form f-start">
                    <div className="w-100 content-box">
                        <div className="content-header">
                            <h3>Profile Info</h3>
                            <h4>Your public profile information</h4>
                        </div>
                        <div className="content-body">
                            <div className="w-100 g f-row f-wrap">
                                {((host.imageUrl && !deleteImage) || !!displayImage) ? (
                                    <div className="p-rel w-20 f-col xs-f-center profile-image-container">
                                        <label>Profile Image</label>
                                        <div className="p-rel w-100 f-col f-center">
                                            <img className="pod-image" src={displayImage ? displayImage : process.env.REACT_APP_MEDIA_URL + host.imageUrl} alt={host.firstName + ' ' + host.lastName} />
                                            <button className="btn-remove-media" onClick={() => {
                                                if (displayImage) {
                                                    setDisplayImage(null);
                                                    setFile(null);
                                                    setFP('');
                                                    return;
                                                }
                                                setDeleteImage(true);
                                            }}>
                                                {'\u00D7'}
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="w-20 xs-f-center profile-image-container">
                                        <label htmlFor="image-file">Profile Image</label>
                                        <div
                                            className={`file-uploader ${isDragging ? 'file-uploader--dragging' : ''} ${previewUrl ? 'file-uploader--has-preview' : ''}`}
                                            onDragOver={handleDragOver}
                                            onDragEnter={handleDragEnter}
                                            onDragLeave={handleDragLeave}
                                            onDrop={handleDrop}
                                            onClick={() => !previewUrl && document.getElementById('image-file').click()}
                                        >
                                            {previewUrl ? (
                                                <div className="p-rel w-100 xs-w-100 f-col f-center">
                                                    <img className="pod-image" src={previewUrl} alt={host.name} />
                                                    <button className="btn-remove-media" onClick={() => {
                                                        URL.revokeObjectURL(previewUrl);
                                                        setPreviewUrl(null);
                                                    }}>
                                                        {'\u00D7'}
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="file-uploader__content">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M14.1673 6.66667L10.0007 2.5L5.83398 6.66667" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M10 2.5V12.5" stroke="#99A1AF" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <span className="file-uploader__text">Upload</span>
                                                </div>
                                            )}
                                        </div>
                                        <input type="file" className="file-uploader__input" id="image-file" accept="image/*" onChange={handleFileChange} value={fp} />
                                    </div>
                                )}
                                <div className="w-20 xs-w-100 f-row f-wrap g c-start">
                                    <div className="w-100">
                                        <label htmlFor="fname">First Name</label>
                                        <input type="text" id="fname" value={host.firstName} onChange={(e) => setValue('firstName', e.target.value)} />
                                    </div>
                                    <div className="w-100">
                                        <label htmlFor="lname">Last Name</label>
                                        <input type="text" id="lname" value={host.lastName} onChange={(e) => setValue('lastName', e.target.value)} />
                                    </div>
                                </div>
                                <div className="w-100">
                                    <label htmlFor="description">Short Bio</label>
                                    <RTE value={host.description} setValue={v => setValue('description', v)} />
                                </div>
                                {/*<div className="w-100">
                                    <label id="episode-content">Select Profile Type</label>
                                    <div className="flex f-row w-100 f-wrap gap-5">
                                        <div className="flex f-row w-30 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => setValue('isHost', !e.target.querySelector('input').checked)}>
                                            <label htmlFor="is-host" className="ml-auto mb-0" style={{ pointerEvents: 'none' }}>Host Profile</label>
                                            <input type="checkbox" className="ml-auto" id="is-host" style={{ pointerEvents: 'none' }} checked={host.isHost} />
                                        </div>

                                        <div className="flex f-row w-30 b-1 b-radius-3 p-5 cursor-pointer" onClick={e => setValue('isGuest', !e.target.querySelector('input').checked)}>
                                            <label htmlFor="is-guest" className="ml-auto mb-0" style={{ pointerEvents: 'none' }}>Guest Profile</label>
                                            <input type="checkbox" className="ml-auto" id="is-guest" style={{ pointerEvents: 'none' }} checked={host.isGuest} />
                                        </div>
                                    </div>
                                </div>*/}
                                <div className="w-100">
                                    <label id="host-profession">Profession - (Select 2 Max)</label>
                                    <div className="flex f-row w-100 f-wrap gap-10">
                                        {host.metaData?.professions?.map((p, i) => (
                                            <div className="profession-button" key={i}>
                                                {p}
                                                <a role="button" className="ml-auto" onClick={() => {
                                                    var prof = host.metaData?.professions;
                                                    prof.splice(i, 1);
                                                    setMetaData('professions', prof);
                                                }}>
                                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9 3L3 9" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3 3L9 9" stroke="#99A1AF" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </a>
                                            </div>
                                        ))}
                                        {(!host.metaData?.professions || host.metaData?.professions?.length < 2) && (
                                            <a role="button" className="profession-button profession-button-add" onClick={() => addProfessionRef.current.show()}>
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.5 6H9.5" stroke="#155DFC" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6 2.5V9.5" stroke="#155DFC" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Add Profession
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                                        
                    <Expandable title="Social Media Links" subTitle="Connect your social profiles">
                        <div className="w-100 gap-10 f-row f-wrap">
                            <div className="w-100">
                                <label htmlFor="twitter">X/Twitter</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.6673 2.66672C14.6673 2.66672 14.2007 4.06672 13.334 4.93339C14.4007 11.6001 7.06732 16.4667 1.33398 12.6667C2.80065 12.7334 4.26732 12.2667 5.33398 11.3334C2.00065 10.3334 0.333984 6.40006 2.00065 3.33339C3.46732 5.06672 5.73398 6.06672 8.00065 6.00006C7.40065 3.20006 10.6673 1.60006 12.6673 3.46672C13.4007 3.46672 14.6673 2.66672 14.6673 2.66672Z" stroke="#101828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <input id="twitter" type="text" value={getSocialUrl('X/Twitter')} onChange={(e) => setSocial('X/Twitter', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="facebook">Facebook</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9993 1.33337H9.99935C9.11529 1.33337 8.26745 1.68456 7.64233 2.30968C7.01721 2.93481 6.66602 3.78265 6.66602 4.66671V6.66671H4.66602V9.33337H6.66602V14.6667H9.33268V9.33337H11.3327L11.9993 6.66671H9.33268V4.66671C9.33268 4.4899 9.40292 4.32033 9.52794 4.1953C9.65297 4.07028 9.82254 4.00004 9.99935 4.00004H11.9993V1.33337Z" stroke="#155DFC" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <input id="facebook" type="text" value={getSocialUrl('Facebook')} onChange={(e) => setSocial('Facebook', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="instagram">Instagram</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_148_306)">
                                            <path d="M11.334 1.33337H4.66732C2.82637 1.33337 1.33398 2.82576 1.33398 4.66671V11.3334C1.33398 13.1743 2.82637 14.6667 4.66732 14.6667H11.334C13.1749 14.6667 14.6673 13.1743 14.6673 11.3334V4.66671C14.6673 2.82576 13.1749 1.33337 11.334 1.33337Z" stroke="#F6339A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10.6658 7.57996C10.7481 8.13479 10.6533 8.70143 10.395 9.1993C10.1367 9.69717 9.72792 10.1009 9.2269 10.3531C8.72589 10.6052 8.15812 10.693 7.60434 10.6039C7.05057 10.5148 6.53899 10.2533 6.14238 9.85673C5.74577 9.46012 5.48431 8.94854 5.3952 8.39477C5.30609 7.84099 5.39386 7.27322 5.64604 6.77221C5.89821 6.27119 6.30194 5.86245 6.79981 5.60412C7.29768 5.34579 7.86432 5.25102 8.41915 5.33329C8.9851 5.41721 9.50905 5.68093 9.91362 6.08549C10.3182 6.49006 10.5819 7.01401 10.6658 7.57996Z" stroke="#F6339A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.666 4.33337H11.6727" stroke="#F6339A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_148_306">
                                                <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <input id="instagram" type="text" value={getSocialUrl('Instagram')} onChange={(e) => setSocial('Instagram', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="tiktok">TikTok</label>
                                <div className="input-with-icon">
                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.00035511 4.79403V3.27273H7.16797V4.79403H4.49609V12H2.67223V4.79403H0.00035511ZM8.01598 4.79403V3.27273H15.1836V4.79403H12.5117V12H10.6879V4.79403H8.01598Z" fill="#101828"/>
                                    </svg>
                                    <input id="tiktok" type="text" value={getSocialUrl('TikTok')} onChange={(e) => setSocial('TikTok', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="youtube">YouTube</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.66569 11.3333C1.19998 9.13551 1.19998 6.86449 1.66569 4.66667C1.72689 4.44347 1.84512 4.24005 2.00877 4.0764C2.17241 3.91276 2.37583 3.79453 2.59903 3.73333C6.17466 3.14097 9.8234 3.14097 13.399 3.73333C13.6222 3.79453 13.8256 3.91276 13.9893 4.0764C14.1529 4.24005 14.2712 4.44347 14.3324 4.66667C14.7981 6.86449 14.7981 9.13551 14.3324 11.3333C14.2712 11.5565 14.1529 11.7599 13.9893 11.9236C13.8256 12.0872 13.6222 12.2055 13.399 12.2667C9.82341 12.8591 6.17465 12.8591 2.59903 12.2667C2.37583 12.2055 2.17241 12.0872 2.00877 11.9236C1.84512 11.7599 1.72689 11.5565 1.66569 11.3333Z" stroke="#E7000B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M6.66602 10L9.99935 8L6.66602 6V10Z" stroke="#E7000B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <input id="youtube" type="text" value={getSocialUrl('YouTube')} onChange={(e) => setSocial('YouTube', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="linkedin">LinkedIn</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.666 5.33337C11.7269 5.33337 12.7443 5.7548 13.4944 6.50495C14.2446 7.25509 14.666 8.27251 14.666 9.33337V14H11.9993V9.33337C11.9993 8.97975 11.8589 8.64061 11.6088 8.39057C11.3588 8.14052 11.0196 8.00004 10.666 8.00004C10.3124 8.00004 9.97326 8.14052 9.72321 8.39057C9.47316 8.64061 9.33268 8.97975 9.33268 9.33337V14H6.66602V9.33337C6.66602 8.27251 7.08744 7.25509 7.83759 6.50495C8.58773 5.7548 9.60515 5.33337 10.666 5.33337Z" stroke="#1447E6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M4.00065 6H1.33398V14H4.00065V6Z" stroke="#1447E6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M2.66732 4.00004C3.4037 4.00004 4.00065 3.40309 4.00065 2.66671C4.00065 1.93033 3.4037 1.33337 2.66732 1.33337C1.93094 1.33337 1.33398 1.93033 1.33398 2.66671C1.33398 3.40309 1.93094 4.00004 2.66732 4.00004Z" stroke="#1447E6" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <input id="linkedin" type="text" value={getSocialUrl('LinkedIn')} onChange={(e) => setSocial('LinkedIn', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="linkedin">BlueSky</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" fill="#1082fe" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M439.8 358.7C436.5 358.3 433.1 357.9 429.8 357.4C433.2 357.8 436.5 358.3 439.8 358.7zM320 291.1C293.9 240.4 222.9 145.9 156.9 99.3C93.6 54.6 69.5 62.3 53.6 69.5C35.3 77.8 32 105.9 32 122.4C32 138.9 41.1 258 47 277.9C66.5 343.6 136.1 365.8 200.2 358.6C203.5 358.1 206.8 357.7 210.2 357.2C206.9 357.7 203.6 358.2 200.2 358.6C106.3 372.6 22.9 406.8 132.3 528.5C252.6 653.1 297.1 501.8 320 425.1C342.9 501.8 369.2 647.6 505.6 528.5C608 425.1 533.7 372.5 439.8 358.6C436.5 358.2 433.1 357.8 429.8 357.3C433.2 357.7 436.5 358.2 439.8 358.6C503.9 365.7 573.4 343.5 593 277.9C598.9 258 608 139 608 122.4C608 105.8 604.7 77.7 586.4 69.5C570.6 62.4 546.4 54.6 483.2 99.3C417.1 145.9 346.1 240.4 320 291.1z"/></svg>
                                    <input id="linkedin" type="text" value={getSocialUrl('BlueSky')} onChange={(e) => setSocial('BlueSky', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="linkedin">Discord</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" fill="#5a69fc" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M524.5 133.8C524.3 133.5 524.1 133.2 523.7 133.1C485.6 115.6 445.3 103.1 404 96C403.6 95.9 403.2 96 402.9 96.1C402.6 96.2 402.3 96.5 402.1 96.9C396.6 106.8 391.6 117.1 387.2 127.5C342.6 120.7 297.3 120.7 252.8 127.5C248.3 117 243.3 106.8 237.7 96.9C237.5 96.6 237.2 96.3 236.9 96.1C236.6 95.9 236.2 95.9 235.8 95.9C194.5 103 154.2 115.5 116.1 133C115.8 133.1 115.5 133.4 115.3 133.7C39.1 247.5 18.2 358.6 28.4 468.2C28.4 468.5 28.5 468.7 28.6 469C28.7 469.3 28.9 469.4 29.1 469.6C73.5 502.5 123.1 527.6 175.9 543.8C176.3 543.9 176.7 543.9 177 543.8C177.3 543.7 177.7 543.4 177.9 543.1C189.2 527.7 199.3 511.3 207.9 494.3C208 494.1 208.1 493.8 208.1 493.5C208.1 493.2 208.1 493 208 492.7C207.9 492.4 207.8 492.2 207.6 492.1C207.4 492 207.2 491.8 206.9 491.7C191.1 485.6 175.7 478.3 161 469.8C160.7 469.6 160.5 469.4 160.3 469.2C160.1 469 160 468.6 160 468.3C160 468 160 467.7 160.2 467.4C160.4 467.1 160.5 466.9 160.8 466.7C163.9 464.4 167 462 169.9 459.6C170.2 459.4 170.5 459.2 170.8 459.2C171.1 459.2 171.5 459.2 171.8 459.3C268 503.2 372.2 503.2 467.3 459.3C467.6 459.2 468 459.1 468.3 459.1C468.6 459.1 469 459.3 469.2 459.5C472.1 461.9 475.2 464.4 478.3 466.7C478.5 466.9 478.7 467.1 478.9 467.4C479.1 467.7 479.1 468 479.1 468.3C479.1 468.6 479 468.9 478.8 469.2C478.6 469.5 478.4 469.7 478.2 469.8C463.5 478.4 448.2 485.7 432.3 491.6C432.1 491.7 431.8 491.8 431.6 492C431.4 492.2 431.3 492.4 431.2 492.7C431.1 493 431.1 493.2 431.1 493.5C431.1 493.8 431.2 494 431.3 494.3C440.1 511.3 450.1 527.6 461.3 543.1C461.5 543.4 461.9 543.7 462.2 543.8C462.5 543.9 463 543.9 463.3 543.8C516.2 527.6 565.9 502.5 610.4 469.6C610.6 469.4 610.8 469.2 610.9 469C611 468.8 611.1 468.5 611.1 468.2C623.4 341.4 590.6 231.3 524.2 133.7zM222.5 401.5C193.5 401.5 169.7 374.9 169.7 342.3C169.7 309.7 193.1 283.1 222.5 283.1C252.2 283.1 275.8 309.9 275.3 342.3C275.3 375 251.9 401.5 222.5 401.5zM417.9 401.5C388.9 401.5 365.1 374.9 365.1 342.3C365.1 309.7 388.5 283.1 417.9 283.1C447.6 283.1 471.2 309.9 470.7 342.3C470.7 375 447.5 401.5 417.9 401.5z"/></svg>
                                    <input id="linkedin" type="text" value={getSocialUrl('Discord')} onChange={(e) => setSocial('Discord', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="website">Website</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_148_346)">
                                            <path d="M8.00065 14.6666C11.6825 14.6666 14.6673 11.6819 14.6673 7.99998C14.6673 4.31808 11.6825 1.33331 8.00065 1.33331C4.31875 1.33331 1.33398 4.31808 1.33398 7.99998C1.33398 11.6819 4.31875 14.6666 8.00065 14.6666Z" stroke="#00A63E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8.00065 1.33331C6.28881 3.13075 5.33398 5.51781 5.33398 7.99998C5.33398 10.4822 6.28881 12.8692 8.00065 14.6666C9.71249 12.8692 10.6673 10.4822 10.6673 7.99998C10.6673 5.51781 9.71249 3.13075 8.00065 1.33331Z" stroke="#00A63E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M1.33398 8H14.6673" stroke="#00A63E" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_148_346">
                                                <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <input id="website" type="text" value={getSocialUrl('Website')} onChange={(e) => setSocial('Website', e.target.value)} />
                                </div>
                            </div>
                            <div className="w-100">
                                <label htmlFor="email">Email</label>
                                <div className="input-with-icon">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.334 2.66669H2.66732C1.93094 2.66669 1.33398 3.26364 1.33398 4.00002V12C1.33398 12.7364 1.93094 13.3334 2.66732 13.3334H13.334C14.0704 13.3334 14.6673 12.7364 14.6673 12V4.00002C14.6673 3.26364 14.0704 2.66669 13.334 2.66669Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M14.6673 4.66669L8.68732 8.46669C8.4815 8.59564 8.24353 8.66403 8.00065 8.66403C7.75777 8.66403 7.5198 8.59564 7.31398 8.46669L1.33398 4.66669" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    <input type="email" id="email" value={getSocialUrl('Email')} onChange={(e) => setSocial('Email', e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </Expandable>
                    
                    {role != 'Host/Guest' && (
                        <>
                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[0] + 1 }}>
                                <ModulePosition position={positions[0]} index="0" setPositions={setPositions} />
                                
                                <h3 className="mb-10">Images</h3>
                                <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={host.images ?? []}
                                    onOrderChange={(newList) => {
                                        setHost(h => {
                                            var newH = {...h};
                                            newH.images = newList;
                                            return newH;
                                        });
                                    }}
                                    itemClass="card-item-2"
                                    renderItem={(h, i) => (
                                        <>
                                            <div className="mb-5">Image {i + 1}</div>
                                            <ImageCard image={h} onRemove={(_id) => {
                                                var index = host.images.findIndex(h => h.id == _id);
                                                if (index < 0)
                                                    return;
                                                setHost(_e => {
                                                    let e = { ..._e };
                                                    e.images.splice(index, 1);
                                                    return e;
                                                });
                                            }} key={i} />
                                        </>
                                    )} endItem={
                                        <div className="card-item card-item-2">
                                            <div className="mb-5">Image {(host.images?.length || 0) + 1}</div>
                                            <button className="add-item add-item-2 aspect-1" onClick={() => {
                                                addImageRef.current.show();
                                            }}>
                                                <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                                                <span>Add Image</span>
                                            </button>
                                        </div>
                                    } />
                            </div>

                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[1] + 1 }}>
                                <ModulePosition position={positions[1]} index="1" setPositions={setPositions} />
                                <h3 className="mb-10">Videos</h3>
                                <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={host.videos ?? []}
                                    onOrderChange={(newList) => {
                                        setHost(h => {
                                            var newH = {...h};
                                            newH.videos = newList;
                                            return newH;
                                        });
                                    }}
                                    itemClass="card-item"
                                    renderItem={(h, i) => (
                                        <>
                                            <div className="mb-5">Video {i + 1}</div>
                                            <VideoCard video={h} onRemove={(vu) => {
                                                var index = host.videos.findIndex(h => h.videoUrl == vu);
                                                if (index < 0)
                                                    return;
                                                setHost(_e => {
                                                    let e = { ..._e };
                                                    e.videos.splice(index, 1);
                                                    return e;
                                                });
                                            }} key={i} />
                                        </>
                                    )} endItem={
                                        <div className="card-item">
                                            <div className="mb-5">Video {(host.videos?.length || 0) + 1}</div>
                                            <button className="add-item" onClick={() => {
                                                addVideoRef.current.show();
                                            }}>
                                                <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                                                <span>Add Video</span>
                                            </button>
                                        </div>
                                    } />
                            </div>

                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[2] + 1 }}>
                                <ModulePosition position={positions[2]} index="2" setPositions={setPositions} />
                                <h3 className="mb-10">Web Links</h3>
                                
                                <SortableContainer containerClass="w-100 gap-10 card-container" containerStyles={{flex: 0}} items={host.links ?? []}
                                    onOrderChange={(newList) => {
                                        setHost(h => {
                                            var newH = {...h};
                                            newH.links = newList;
                                            return newH;
                                        });
                                    }}
                                    itemClass="card-item-3"
                                    renderItem={(h, i) => (
                                        <>
                                            <div className="mb-5">{h.isDownload ? "Download" : "Link"} {i + 1}</div>
                                            <LinkCard link={h} onRemove={(v) => {
                                                var index = host.links.findIndex(h => h.url == v.url && h.text == v.text);
                                                if (index < 0)
                                                    return;
                                                setHost(_e => {
                                                    let e = { ..._e };
                                                    e.links.splice(index, 1);
                                                    return e;
                                                });
                                            }} key={String(i)} />
                                        </>
                                    )} endItem={
                                        <div className="card-item card-item-3">
                                            <div className="mb-5">Link {(host.links?.length || 0) + 1}</div>
                                            <button className="add-item add-item-3" style={{flexDirection: 'row', minHeight: 55.2}} onClick={() => {
                                                linkRef.current.show();
                                            }}>
                                                <FontAwesomeIcon icon={faPlusCircle} className="add-icon" />
                                                <span>Add Link or Download</span>
                                            </button>
                                        </div>
                                    } />
                            </div>

                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[3] + 1}}>
                                <ModulePosition position={positions[3]} index="3" setPositions={setPositions} />
                                <h3 className="mb-10">Merch</h3>
                                {!!id && (<div className="f-start f-row mt-5 mb-10 f-between">
                                    <Link to="/merch" state={{speaker: {...host, id}, returnTo: location.pathname}}>Create New Merch</Link>
                                    <Link to="/">
                                        <FontAwesomeIcon icon={faRepeat} /> Sort Merch Order
                                    </Link>
                                </div>)}
                                {merch?.length > 0 && false && (
                                    <div className="w-100">
                                        <label htmlFor="find-events">Add Merch</label>
                                        <div className="w-100 gap-10 f-row mb-10">
                                            <select id="find-events" className="w-100" onChange={(e) => setMerchId(e.target.value)} value={merchId}>
                                                <option value={-1}>
                                                    Please Select...
                                                </option>
                                                {filterArrays(merch, host.merch).map((m, i) => (
                                                    <option key={i} value={m.id}>
                                                        {m.id}: {m.name} - ${m.price.toFixed(2)}
                                                    </option>
                                                ))}
                                            </select>
                                            <button className="btn" onClick={() => {
                                                if (merchId == -1)
                                                    return;
                                                var mer = merch.find(m => m.id == merchId);
                                                if (!mer)
                                                    return;
                                                setHost(_h => {
                                                    let h = { ..._h };
                                                    h.merch = h.merch || [];
                                                    h.merch.push(mer);
                                                    setMerchId(-1);
                                                    return h;
                                                });
                                            }}> Add</button>
                                        </div>
                                    </div>
                                )}
                                {host.merch?.length ? (
                                    <SortableContainer containerClass="w-100 gap-10 card-container" items={host.merch}
                                        onOrderChange={(newList) => {
                                            setHost(h => {
                                                var newH = {...h};
                                                newH.merch = newList;
                                                return newH;
                                            });
                                            axios.post(process.env.REACT_APP_API_URL + 'rank/update', {
                                                ids: JSON.stringify(newList.map(m => m.id)),
                                                ranks: JSON.stringify(newList.map((m, i) => i + 1)),
                                                type: 'speakermerch'
                                            })
                                        }}
                                        renderItem={(m, i) => (
                                            <MerchCard merch={m} speaker={host} key={i} onRemove={(_id) => {
                                                var index = host.merch.findIndex(m => m.id == _id);
                                                /*if (index < 0)
                                                    return;
                                                setHost(_h => {
                                                    let h = { ..._h };
                                                    h.merch.splice(index, 1);
                                                    return h;
                                                });*/
                                                axios.post(process.env.REACT_APP_API_URL + 'merch/delete', {
                                                    ids: JSON.stringify([_id]),
                                                    urls: JSON.stringify([host.merch[index].imageUrl])
                                                }).then(r => {
                                                    if (r?.data?.status === 'Success') {
                                                        loadHost();
                                                    }
                                                });
                                            }} />
                                        )} />
                                ) : (
                                    <div className="text-center">No Merch</div>
                                )}
                            </div>

                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[4] + 1 }}>
                                <ModulePosition position={positions[4]} index="4" setPositions={setPositions} />
                                <h3 className="mb-10">Upcoming Events</h3>
                                {!!id && (<div className="f-start f-row mt-5 mb-10">
                                    <Link to="/event" state={{speaker: {...host, id}, returnTo: location.pathname}}>Create New Event</Link>
                                </div>)}
                                {events?.length > 0 && false && (
                                    <div className="w-100">
                                        <label htmlFor="find-events">Add Event</label>
                                        <div className="w-100 gap-10 f-row mb-10">
                                            <select id="find-events" className="w-100" onChange={(e) => setEventId(e.target.value)} value={eventId}>
                                                <option value={-1}>
                                                    Please Select...
                                                </option>
                                                {filterArrays(events, host.events).map((e, i) => (
                                                    <option key={i} value={e.id}>
                                                        {e.id}: {e.title} - {(new Date(e.datetime)).toLocaleString()}
                                                    </option>
                                                ))}
                                            </select>
                                            <button className="btn" onClick={() => {
                                                if (eventId == -1)
                                                    return;
                                                var ev = events.find(e => e.id == eventId);
                                                if (!ev)
                                                    return;
                                                setHost(_h => {
                                                    let h = { ..._h };
                                                    h.events = h.events || [];
                                                    h.events.push(ev);
                                                    setEventId(-1);
                                                    return h;
                                                });
                                            }}> Add</button>
                                        </div>
                                    </div>
                                )}
                                <div className="w-100 gap-10 card-container">
                                    {host.events?.length ? host.events.sort((a, b) => new Date(a.datetime) - new Date(b.datetime)).filter(d => new Date(d.datetime) > now).map((e, i) => {
                                        return (
                                            <EventCard event={e} speaker={host} onRemove={(_id) => {
                                                /*var index = host.events.findIndex(e => e.id == _id);
                                                if (index < 0)
                                                    return;
                                                setHost(_h => {
                                                    let h = { ..._h };
                                                    h.events.splice(index, 1);
                                                    return h;
                                                });*/
                                                axios.post(process.env.REACT_APP_API_URL + 'event/delete', {
                                                    ids: JSON.stringify([_id])
                                                }).then(r => {
                                                    if (r?.data?.status === 'Success') {
                                                        loadHost();
                                                    }
                                                });
                                            }} key={i} />
                                        );
                                    }) : (
                                    <div className="text-center">No Upcoming Events</div>     
                                    )}
                                </div>
                            </div>

                            <div className="w-50 sm-w-100 b-radius-4 b-1 p-10 p-rel bg-white" style={{ order: positions[5] + 1 }}>
                                <ModulePosition position={positions[5]} index="5" setPositions={setPositions} />
                                <h3 className="mb-10">Episodes</h3>
                                <div className="f-start f-row mt-5 mb-10">
                                    <Link to="/episode-list">View Episodes</Link>
                                </div>
                                <div className="w-100 gap-10 card-container">
                                    {host.episodes?.length ? host.episodes.sort((a, b) => new Date(a.airDate) - new Date(b.airDate)).map((e, i) => {
                                        return <EpisodeCard episode={e} key={i} />
                                    }) : (
                                        <div className="text-center">No Episodes</div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                    

                    <div className="w-100 content-box">
                        <div className="content-body">
                            <div className="w-100 f-end f-row a-center" style={{ order: 10 }}>
                                <div className="pod-date-string">
                                    Last Saved: <span>{formatDate(host.updatedDate || host.createdDate)}</span>
                                </div>
                                <div  className="flex f-center f-row gap-15" style={{flexGrow: 0}}>
                                    <button className="btn btn-white flex f-row g-5" onClick={() => window.location.reload()}>
                                        Discard
                                    </button>
                                    <button onClick={save} className="btn flex f-row g-5">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.3327 14V9.33329C11.3327 9.15648 11.2624 8.98691 11.1374 8.86189C11.0124 8.73686 10.8428 8.66663 10.666 8.66663H5.33268C5.15587 8.66663 4.9863 8.73686 4.86128 8.86189C4.73625 8.98691 4.66602 9.15648 4.66602 9.33329V14" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4.66602 2V4.66667C4.66602 4.84348 4.73625 5.01305 4.86128 5.13807C4.9863 5.2631 5.15587 5.33333 5.33268 5.33333H9.99935" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        Save
                                    </button>
                                    {role != 'Host/Guest' && (
                                        <>
                                            {id && <button onClick={() => {
                                                setId(null);
                                                setHost(defaultHost);
                                                setEventId(-1);
                                                setMerchId(-1);
                                                setFile(null);
                                                setFP('');
                                                setDeleteImage(false);
                                                setLoading(true);
                                            }} className="btn">New</button>}
                                            <Link className="btn" to="/host-list">Cancel</Link>
                                            {id && <button onClick={_delete} className="btn btn-red">Delete</button>}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default Host;